export default "__VITE_ASSET__5y$uIgam__"